/**
 * seriesData 数据结构
 * {
 *   name: 'xxx',
 *   data: [1,2,3,4,5],
 *   color: '#000000',
 *   type: 'line'
 * }
 * xAxisData 数据结构
 * []
 * legendData 数据结构
 * 自动根据seriesDatas生成
 * ***/ 
import { chartAllColors } from '@sg/utils/useChartOptions';


export const DefaultChatsValue = (data?: any)=> {
  const {xAxisData, seriesData, type, yAxis} = data;
  const legendData: any = [];
  const seriesDatas = seriesData.map((item: any, index: number) => {
    // Only add to legend if not marked as hidden (opt-in per series)
    if (!item?.hiddenFromLegend) {
      legendData.push({
        name: item?.name,
        itemStyle: {
          ...item?.itemStyle,
          // Legend uses series.color (solid); bar fill may override via itemStyle.color.
          color: item?.color || chartAllColors[index],
        },
      });
    }
    return {
      ...item,
      name: item?.name,
      type: item?.type || type,
      data: item?.data,
      itemStyle: {
        color: item?.color || chartAllColors[index],
        ...item?.itemStyle
      },
      symbolSize: item?.symbolSize || 10
    };
  });
  
  return {
    grid: {
      top: '4%',   // 距离容器上边缘的距离
      containLabel: true // 是否包含坐标轴标签
    },
    tooltip: {
      trigger: 'axis',
      borderWidth: 0,
      padding: 0,
      confine: true,
      extraCssText: 'z-index:8',
    },
    legend: {
      data: legendData || [],
    },
    xAxis: {
      type: 'category',
      boundaryGap: true,
      data: xAxisData,
      axisLabel: {
        rich: {
          bold: {
            fontWeight: 'bold',
            color: '#838697'
          },
          normal: {
            fontWeight: 'normal',
            color: '#838697'
          }
        },
        interval: 0,
        fontSize: 10,
        showMaxLabel: true
      },
      axisTick: {
        alignWithLabel: true,
      },
      axisLine: {
        lineStyle: {
          type: 'solid',
          color: '#A2A4B1',
          width: 1, //坐标线的宽度
        },
      },
    },
    yAxis: yAxis ? yAxis : {
      type: 'value',
      axisLabel: {
        fontSize: 11
      },
    },
    series: seriesDatas
  };
};